<template>
  <div id="roster-monthly-calendar">
    <b-overlay :show="loading">
      <div class="">
        <div class="position-fixed end-0 top-50 translate-middle-y" style="right: 0; top: 50%;transform: translateY(-50%); z-index: 99;">
          <b-button v-b-tooltip.hover.left="'View all shifts for this date pl-4'" id="filter_button" style="border-bottom-left-radius: 50px; border-top-left-radius: 50px;" v-b-toggle.sidebar_right><b-icon icon="info-circle-fill"></b-icon> Shifts</b-button>
        </div>

        <div class="ibox-title dashboard_title company-form-box-title pl-0 mb-3">
            <h4 class="clearfix">
                <span class="float-left">View monthly employee shifts, leaves, and holidays for the selected date range within that month.</span>
                <span class="float-right"></span>
            </h4>
        </div>

        <b-sidebar id="sidebar_right" title="Shifts" width="500px" right shadow :no-close-on-esc="false" :no-close-on-backdrop="false">
          <div class="table-responsive employee-table-wrapper px-3">
            <table class="employee-list-table table table-hover dataTable table-overflow table-sticky">
              <thead class="table-head">
              <tr>
                <th>Shift Name</th>
                <th>Code</th>
                <th>Start Time</th>
                <th>End Time</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="s in shifts" :key="s.id" class="hover-bg table-row border-bottom mx-2" :style="{ background: s.color+'22' , color:s.color}">
                <td>{{ s.name }}</td>
                <td>{{ s.code }}</td>
                <td>{{ moment(s.start_time, 'HH:mm:ss').format('hh:mm A') }}</td>
                <td>{{ moment(s.end_time, 'HH:mm:ss').format('hh:mm A') }}</td>
              </tr>
              </tbody>
            </table>
            <div v-if="shifts.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
          </div>
        </b-sidebar>

        <div class="ibox py-3 px-3 mb-3">
          <h5>Choose a date range to view the Monthly Report.</h5>
          <b-form @submit.stop.prevent="loadData">
            <b-row class="align-items-end">
              <b-col cols="12" md="3" lg="2">
                <b-form-group id="effective_start_date-group" label-for="effective_start_date" class="mb-0">
                  <template #label>
                    Start Date &nbsp;<b-icon icon="info-circle" v-b-tooltip.hover.top="'Select start date for the monthly report.'"></b-icon>
                  </template>
                  <b-input-group class="mb-0">
                    <b-form-input id="effective_start_date" name="effective_start_date" v-model="start" v-validate="{ required: true, date_format: 'yyyy-mm-dd' }" type="text" placeholder="YYYY-MM-DD"
                                  autocomplete="off" :state="validateState('effective_start_date')" aria-describedby="effective_start_date-feedback" data-vv-as="Start Date"/>
                    <b-input-group-append class="mb-0">
                      <b-form-datepicker class="mb-0" id="day_one" button-only right locale="en-US" v-model="start" @input="end = start" />
                    </b-input-group-append>
                    <b-form-invalid-feedback id="effective_start_date-feedback">
                      {{ veeErrors.first('effective_start_date') }}
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="3" lg="2">
                <b-form-group id="effective_end_date-group" label-for="effective_end_date" class="mb-0">
                  <template #label>
                    End Date &nbsp;<b-icon icon="info-circle" v-b-tooltip.hover.top="'Select end date for the monthly report.'"></b-icon>
                  </template>
                  <b-input-group class="mb-0">
                    <b-form-input id="effective_end_date" name="effective_end_date" v-model="end" v-validate="{ required: true, date_format: 'yyyy-mm-dd' }" type="text" placeholder="YYYY-MM-DD"
                                  autocomplete="off" :state="validateState('effective_end_date')" aria-describedby="effective_end_date-feedback" data-vv-as="End Date"/>
                    <b-input-group-append class="mb-0">
                      <b-form-datepicker class="mb-0" id="day_two" button-only right :min="start" locale="en-US" v-model="end" />
                    </b-input-group-append>
                    <b-form-invalid-feedback id="effective_end_date-feedback">
                      {{ veeErrors.first('effective_end_date') }}
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6" lg="8" class="mb-2 mb-md-0 d-flex flex-row align-items-end justify-content-start">
                <b-button v-b-tooltip.hover.top="'Preview the monthly report for the selected date range.'" class="mr-2" @click="loadData" :disabled="!start || !end">Preview Report</b-button>
              </b-col>
            </b-row>
          </b-form>
        </div>

        <b-alert v-if="error" show variant="danger" class="mb-3">{{ error }}</b-alert>
        <b-alert v-else-if="!loading && daysData.length == 0" show variant="info" class="mb-3">
          No days to display. Pick a valid date range and click <b>Preview Report</b>.
        </b-alert>

        <div>
          <div style="display: grid; grid-template-columns: repeat(7, 1fr); gap: 12px; margin-bottom: 10px; padding: 6px 2px;
            font-weight: 600; font-size: 16px; text-align: center; color: #111827;">
            <div v-for="day in ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']" :key="day"> {{ day }} </div>
          </div>
        </div>

        <b-row v-if="!loading"
        style="font-size: 12px;display: grid !important; grid-template-columns: repeat(7, 1fr); grid-auto-rows: 168px; row-gap: 15px;
        column-gap: 15px; margin-left: 0 !important; margin-right: 0 !important;">
        <b-col v-for="(d, i) in daysData" :key="d.date" class="calendar-cell p-0" :style="i == 0 ? { gridColumnStart: (new Date(d.date).getDay() + 1) } : null">
          <b-card header-class="p-1 bg-wash border-0 rounded" no-body class="mb-0 h-100" :style="{
              padding: '0 2px',
              border: '1px solid #0b5ebd',
              border: d.date == toYMD(new Date()) ? '2px solid #1d4ed8' : '1px solid #1d4ed8',
              borderRadius: '10px'
            }">
            <template #header>
              <div class="d-flex justify-content-between align-items-center p-0 border-bottom my-1">
                <strong>{{ moment(d.date).format('DD MMM') }}</strong>
                <b-badge pill variant="light">{{ d.total }} Employees</b-badge>
              </div>
            </template>

            <b-list-group flush>
              <b-list-group-item
                v-for="(g, idx) in d.shiftGroups.slice(0, 2)"
                :key="`${d.date}-${g.shift_id}-${idx}`"
                class="px-1 pb-1 pt-0 border-0"
              >
                <div
                  role="button"
                  tabindex="0"
                  class="w-100 text-left rounded p-2 cursor-pointer"
                  :style="{ background: (g.shift && g.shift.color ? g.shift.color : '#f3f4f6') + '22' }"
                  @click="openShiftModal(d.date, g.shift, g.employee_ids)"
                  @keyup.enter="openShiftModal(d.date, g.shift, g.employee_ids)"
                >
                  <b-badge pill variant="light">{{ g.count }}x</b-badge>

                  <span
                    class="mx-1 px-1 rounded"
                    :style="{ color: g.shift && g.shift.color ? g.shift.color : '#111827' }"
                  >
                    {{ g.shift && g.shift.name ? g.shift.name : 'Unassigned' }}
                  </span>
                </div>
              </b-list-group-item>

              <b-list-group-item
                v-if="d.shiftGroups.length > 2"
                class="p-1 border-0"
              >
                <div
                  role="button"
                  tabindex="0"
                  class="w-100 text-center rounded p-2 text-white cursor-pointer btn-submitted"
                  @click="openShiftListModal(d.date, d.shiftGroups)"
                  @keyup.enter="openShiftListModal(d.date, d.shiftGroups)"
                >
                  View All Shifts ({{ d.shiftGroups.length }})…
                </div>
              </b-list-group-item>

              <div
                v-if="d.shiftGroups.length == 0"
                class="text-muted small p-1"
              >
                No assignments found in this date.
              </div>
            </b-list-group>
          </b-card>
        </b-col>
      </b-row>
    </div>
    </b-overlay>

    <b-modal id="shift-employee-modal" v-model="modal.show" title="" size="xxl" hide-footer body-class="p-0">
      <div class="modal-head rounded p-3 pb-2">
        <div class="d-flex align-items-start justify-content-between">
          <div class="border rounded p-4">
            <div class="d-flex align-items-center mb-1">
              <span class="mr-2 p-2 rounded" :style="{background: modal.shift ? modal.shift.color : 'red'}"></span>
              <h4 class="mb-0">
                {{ (modal.shift && modal.shift.name) ? modal.shift.name : 'No Shift' }}
                <span v-if="modal.shift && modal.shift.start_time">
                  {{ moment(modal.shift.start_time, "HH:mm:ss").format("hh:mm A") }}
                </span>
                <span v-if="modal.shift && modal.shift.end_time">
                  {{ moment(modal.shift.end_time, "HH:mm:ss").format("hh:mm A") }}
                </span>
              </h4>
            </div>
            <div class="text-muted small">{{ moment(modal.date).format('dddd, MMMM D, YYYY') }}</div>
          </div>
        </div>
      </div>

      <div class="px-3 pb-2 d-flex align-items-center">
        <b-icon icon="people" class="mr-2 text-muted"></b-icon>
        <h6 class="mb-0">Assigned Employees <span class="text-muted">({{ modal.employees.length }})</span></h6>
      </div>

      <div class="table-responsive employee-table-wrapper mt-3 px-3">
        <table class="employee-list-table table table-hover dataTable table-overflow table-sticky">
          <thead>
          <tr class="table-head">
            <th v-for="column in columns" :key="column.name" @click="sortBy(column.name)" :class="sortKey == column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'" class="cursor-pointer"><span>{{column.label}}</span></th>
          </tr>
          </thead>
          <tbody>
          <tr v-b-tooltip.hover="row.data_source" @click="showEmployee(row)" v-for="(row, index) in paginatedData" :key="row.id"  class="hover-bg table-row border-bottom mx-2 cursor-pointer">
            <td>{{index+1}}</td>
            <td>{{ row.employee_code }}</td>
            <td><img :src="$api_url + row.pic" class="mr-2 img-fluid img-thumbnail employee-avatar"  alt="">{{ row.name }}</td>
            <td>{{ row.jobposition }}</td>
            <td>{{ row.department }}</td>
            <td :class="{ 'text-center' : row.check_in == '-' }">{{ row.check_in }}</td>
            <td :class="{ 'text-center' : row.check_out == '-' }">{{ row.check_out }}</td>
            <td :class="{ 'text-center' : row.work_time == '-' }">{{ row.work_time }}</td>
          </tr>
          <tr v-if="!modal.employees.length">
            <td colspan="5" class="text-muted small">No employees assigned.</td>
          </tr>
          </tbody>
        </table>
        <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
        <div v-else class="px-3 mt-4">
          <ul class="pagination b-pagination float-left mb-0 mt-1">
            <li class="page-item disabled m-2">View</li>
            <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
            <li class="page-item disabled m-2">per page. Total {{modal.employees.length}} records found.</li>
          </ul>
          <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>

        </div>
      </div>
    </b-modal>

    <b-modal
      id="bv-shift-list-modal"
      v-model="showShiftListModal"
      size="md"
      :title="`Shifts on ${moment(selectedShiftDate).format('DD MMM YYYY')}`"
      hide-footer
    >
      <b-list-group flush>
        <b-list-group-item
          v-for="(g, idx) in modalShiftGroups"
          :key="`modal-${selectedShiftDate}-${g.shift_id}-${idx}`"
          class="p-1 border-0"
        >
          <div
            role="button"
            tabindex="0"
            class="w-100 text-left rounded p-2 cursor-pointer"
            :style="{ background: (g.shift && g.shift.color ? g.shift.color : '#f3f4f6') + '22' }"
            @click="openShiftModal(selectedShiftDate, g.shift, g.employee_ids)"
            @keyup.enter="openShiftModal(selectedShiftDate, g.shift, g.employee_ids)"
          >
            <b-badge pill variant="light">
              {{ g.count }}x
            </b-badge>

            <span
              class="mx-1 px-1 rounded"
              :style="{ color: g.shift && g.shift.color ? g.shift.color : '#111827' }"
            >
              {{ g.shift && g.shift.name ? g.shift.name : 'Unassigned' }}
            </span>
          </div>
        </b-list-group-item>
      </b-list-group>
    </b-modal>

    <b-modal id="activity_logModal" size="xl" scrollable  hide-footer>
      <template #modal-title>
        <div class="d-flex flex-row align-items-center">
          <div class="mr-3" :style="{height: '25px',width: '25px', background: shift_color, borderRadius: '50%'}"></div> <span>Attendance Info at {{shift_name}}</span>
        </div>
      </template>
      <div class="row no-margin">
        <div class="col-md-6">
          <div class="card punch-status">
            <div class="card-body">
              <h5 class="card-title">Timesheet <small class="text-muted">{{attendances_date}}</small></h5>
              <div class="punch-det">
                <h6>Punch In at</h6>
                <p>{{check_in}}</p>
              </div>
              <div class="punch-info">
                <div class="punch-hours">
                  <span>{{work_time}}</span>
                </div>
              </div>
              <div class="punch-det">
                <h6>Punch Out at</h6>
                <p>{{check_out}}</p>
              </div>
              <div class="punch-det">
                <h6>Overtime</h6>
                <p>{{over_time}}</p>
              </div>
              <div class="punch-det">
                <h6>Break Time</h6>
                <p>{{break_time}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card recent-activity">
            <div class="card-body">
              <h5 class="card-title">Activity</h5>
              <ul class="res-activity-list" v-if="activity_log">
                <li v-for="(activity, index) in activity_log">
                  <p class="mb-0" v-if="index % 2 == 0">Punch In at</p>
                  <p class="mb-0" v-else>Punch Out at</p>
                  <p class="res-activity-time">
                    <i class="far fa-clock"></i>
                    {{ moment(activity, "YYYY-MM-DD HH:mm:ss").format("hh:mm A") }}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    let sortOrders = {};
    let columns = [
      {label: 'SL', name: 'sl' },
      {label: 'Employee ID', name: 'employee_id' },
      {label: 'Name', name: 'name' },
      {label: 'Job Position', name: 'jobposition' },
      {label: 'Department', name: 'department' },
      {label: 'Check In', name: 'check_in' },
      {label: 'Check Out', name: 'check_out' },
      {label: 'Work Time', name: 'work_time' },
    ];

    columns.forEach((column) => {sortOrders[column.name] = -1;});
    return {
      index: 0,
      date: new Date(),
      start: '',
      end: '',
      search: '',
      daysData: [],
      shifts: [],
      loading: false,
      error: null,
      shift_name: '',
      shift_color: '',
      errors: [],
      showShiftListModal: false,
      selectedShiftDate: null,
      modalShiftGroups: [],
      activity_log: [],
      attendances_date:'',
      check_in:'',
      check_out:'',
      work_time:'',
      over_time:'',
      break_time:'',
      columns:columns,
      sortOrders:sortOrders,
      sortKey:'name',
      pagination: {currentPage: 1, pages:1},
      length_options:
          [
            { value: 20, text: "20" },
            { value: 50, text: "50" },
            { value: 100, text: "100" },
            { value: 500, text: "500" },
            { value: 1500, text: "1500" },
          ],
      temp_length: 100,
      modal: {
        show: false,
        date: '',
        shift_id: null,
        shift: null,
        title: 'Employees',
        employees: [],
      },
    };
  },
  methods: {
    moment,
    openShiftListModal(date, groups) {
      this.selectedShiftDate = date;
      this.modalShiftGroups = groups;
      this.showShiftListModal = true;
    },
    showEmployee(data){
      if(data.activity_log)
      {
        this.activity_log = data.activity_log.sort((a, b) => {
          return new Date(a.time) - new Date(b.time);
        });
        this.check_in = data.check_in;
        this.check_out = data.check_out;
        this.work_time = data.work_time;
        this.break_time = data.break_time;
        this.over_time = data.over_time;
        this.attendances_date = data.period_date;
        this.shift_name = `${data.shift.name} (${data.shift.start_time} - ${data.shift.end_time})`;
        this.shift_color = data.shift.color;
        this.$bvModal.show('activity_logModal');
      }
    },

    validateState(ref) {
      try {
        if (this.veeErrors && typeof this.veeErrors.has == 'function') {
          return this.veeErrors.has(ref) ? false : null;
        }
      } catch (_) {}
      return null;
    },

    parseYMD(str) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(str)) return null;
      const [y, m, d] = str.split('-').map(Number);
      const dt = new Date(y, m - 1, d, 0, 0, 0, 0);
      return dt && dt.getFullYear() == y && dt.getMonth() + 1 == m && dt.getDate() == d ? dt : null;
    },
    toYMD(d) {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    },
    openShiftModal(date,shift, employee_ids = []) {
      this.modal.date = date;
      this.modal.shift = shift;
      let shift_id = 0;
      if(shift == null){
        this.modal.title = `No Shift — ${date}`;
      }
      else {
        this.modal.title = `${shift.name} — ${date}`;
        shift_id = shift.id
      }

      this.modal.employees = [];
      this.modal.show = true;

      axios.get(this.$api_url + '/leave-attendance/assignments/employees', {
        params: {
          date: date,
          employee_ids: JSON.stringify(employee_ids),
          shift_id: shift_id,
        }
      }).then(res => {
        this.modal.employees = res.data;
      }).catch(err => {
        this.serverError(err);
      });
    },
    loadShifts() {
      this.loading = true
      axios.get('/leave-attendance/shifts').then((response) => {
        this.shifts = response.data;
      }).catch(error => {
        this.serverError(error)
      }).finally(() => { this.loading = false });
    },

    loadData() {
      if (!this.start || !this.end) {
        const today = new Date();
        const first = new Date(today.getFullYear(), today.getMonth(), 1);
        const last = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        this.start = this.toYMD(first);
        this.end = this.toYMD(last);
      }

      this.loading = true;
      this.error = null;

      axios.get(this.$api_url + '/leave-attendance/monthly', {params: { start: this.start, end: this.end },}).then(response => {
        this.daysData = response.data;

        const s = this.parseYMD(this.start);
        const e = this.parseYMD(this.end);
        if (s && e) {
          const cur = this.parseYMD(this.toYMD(this.date));
          if (!cur || cur < s || cur > e) this.date = s;
        }

        this.loading = false;
      })
      .catch(e => {
        this.serverError(e);
      });
    },
  },

  computed: {
    filteredData()
    {
      let filtered_list = this.modal.employees;
      if (this.search)
      {
        filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
      }
      let sortKey = this.sortKey;
      let order = this.sortOrders[sortKey] || 1;
      if (sortKey)
      {
        filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
              a = String(a[sortKey]).toLowerCase();
              b = String(b[sortKey]).toLowerCase();
              if (this.columns[index].type && this.columns[index].type == 'date')
              {
                return (a == b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
              }
              else if (this.columns[index].type && this.columns[index].type == 'number')
              {
                return (+a == +b ? 0 : +a > +b ? 1 : -1) * order;
              }
              else
              {
                return (a == b ? 0 : a > b ? 1 : -1) * order;
              }
            }
        );
      }
      return filtered_list;
    },
    paginatedData()
    {
      return this.paginate(this.filteredData, this.temp_length, this.pagination.currentPage);
    },

  },
  mounted() {
    if (!this.start || !this.end) {
      const today = new Date();
      const first = new Date(today.getFullYear(), today.getMonth(), 1);
      const last = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      this.start = this.toYMD(first);
      this.end = this.toYMD(last);
    }
    this.loadData();
    this.loadShifts();
  },
};
</script>


